module.exports = __webpack_public_path__ + "static/media/john-smith.274096ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/john-smith.png
// module id = 459
// module chunks = 108